module.exports = __webpack_public_path__ + "img/pr-3.1e2d79b9.png";